import { fetchFeaturesByStudioId } from '@apps/studioadmin/services/features.service';
import { isServiceSuccess } from '@core/models/actionResponse';
import type { identifier } from '@core/models/base';
import { fetchFeaturesByStudioSlug } from '@apps/customer/services/features.service';
import { FeatureIdentifier, useFeaturesStore } from '@shared/stores/features.store';

export const availableFeaturesFromStudioId = async (studioId: identifier) => {
  const res = await fetchFeaturesByStudioId(studioId);
  return isServiceSuccess(res) ? res.data : [];
};

export const availableFeaturesFromStudioSlug = async (studioSlug: string) => {
  const res = await fetchFeaturesByStudioSlug(studioSlug);
  return isServiceSuccess(res) ? res.data : [];
};

export const hasFeature = (featureIdentifier: FeatureIdentifier) => {
  return useFeaturesStore().hasFeature(featureIdentifier);
};
